import { render, staticRenderFns } from "./ProfileLanguageList.vue?vue&type=template&id=55059512"
import script from "./ProfileLanguageList.vue?vue&type=script&lang=js"
export * from "./ProfileLanguageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports